import { Component, OnInit } from '@angular/core';
import { DataService } from '../../shared/dataservice.service';
import { TblHeadCellDef, UITblGroup, AggregateType, UiTblSubSOBrkPSLevel } from '../../shared/ui-classes';
import { UiTblSubSO, configDefs, Equipment } from '../../shared/misc-classes';
import { GenService } from '../../shared/gen-ser.service';
import { showTblModule } from '../mast-plan/mast-plan.component';
import { SubSOUIPipePipe } from '../../filters/sub-souipipe.pipe';


@Component({
	selector: 'manf-plan',
	templateUrl: './manf-plan.component.html',
	styleUrls: ['../mast-plan/mast-plan.component.css']
})
export class ManfPlanComponent implements OnInit {

	headRows: Array<TblHeadCellDef> = [];
	filteredHeadRows: Array<TblHeadCellDef> = [];
	_filterPipe: SubSOUIPipePipe = new SubSOUIPipePipe();
	_subSoUIObjList: Array<UiTblSubSOBrkPSLevel>;
	_filteredSubSoUIObjList: Array<UiTblSubSOBrkPSLevel>;
	search: string = '';
	tblModStatus: showTblModule = new showTblModule();
	isFullScreenTbl: boolean = false;
	
	isLoading:boolean = false;

	constructor(private _dataService: DataService) { }

	ngOnInit() {
		this.isLoading = true;
		this._dataService.currPageName = 'Manufacturing Plan';
		this.headRows = this.initTableHeaders();
		this.arrangeHeadColumns();
		this._dataService.getDataDefinitions().subscribe(res => {
			this.loadData();
		});
	}

	loadData(): void {
		this.isLoading = true;
		this._dataService.getAllSalesOrder(1).subscribe((saleOrders) => {
			let _tmpSubSoUIObjList: Array<UiTblSubSOBrkPSLevel> = [];
			let _tmpFirstSOObj: UiTblSubSOBrkPSLevel;
			let _tmpFirstSubSOObj: UiTblSubSOBrkPSLevel;
			saleOrders.forEach((saleOrder) => {
				let isFirstRowInSO: boolean = true;

				saleOrder.subSalesOrder.forEach((subSO) => {

					let isFirstRowInSubOrder: boolean = true;
					subSO.pmTechSubSalesOrder.equipmentList.forEach((equipment) => {
						let _tmpObj = new UiTblSubSOBrkPSLevel(subSO, equipment,null, isFirstRowInSO, isFirstRowInSubOrder,null);
						_tmpSubSoUIObjList.push(_tmpObj);

						if (isFirstRowInSO) {
							_tmpFirstSOObj = _tmpObj;
						}
						if (isFirstRowInSubOrder) {
							_tmpFirstSubSOObj = _tmpObj;
						}

						_tmpFirstSOObj.totalBreakerPsCountForSo++;
						_tmpFirstSubSOObj.totalBreakerPsCountForSubSo++;

						isFirstRowInSubOrder = false;
						isFirstRowInSO = false;
					});
				});
			});


			//init the required ui name
			_tmpSubSoUIObjList.forEach((_subsoUIObj) => {
				this.prepareSSOUIObjData(_subsoUIObj)
			});
			this._subSoUIObjList = _tmpSubSoUIObjList;
		
			this.filterRows();
			this.isLoading = false;
		});
	}	

	getCellRowSpan(_ssoEquipUIObj: UiTblSubSOBrkPSLevel, _columnIndex: number) {
		switch (_columnIndex) {
		  //Sale Order level items here
		  case 0: case 1: case 2:
		  	
			if (_ssoEquipUIObj.isFirstRowInSO)
			  return _ssoEquipUIObj.totalBreakerPsCountForSo;
			else
			  return 0;
	
			break;
	
		  //Sub Order Level Items here
		case 7: //case 8: case 9: case 10: case 11: case 12: case 13: case 14: case 15: case 16: case 17: case 18: case 19: case 20: case 21: 
		// case 22: case 23: case 24: case 25: case 26 : case 27: case 28: case 29: case 30 : case 31:
		 
		 
			if (_ssoEquipUIObj.isFirstRowInSubOrder){
				return _ssoEquipUIObj.totalBreakerPsCountForSubSo;
			}
			
			else{
				return 0;
			}
			  
	
			break;
	
		}
	
	
		return 1;
	  }

	getCellValue(_subsoUIObj: UiTblSubSOBrkPSLevel, _paramNumber: number): string {
		switch (_paramNumber) {
			case 0:
				return _subsoUIObj.plannedManfMonth;
			case 1:
				return _subsoUIObj.customerName;
			case 2:
				return _subsoUIObj.salesOrderNo;
			case 3:
				return _subsoUIObj.subSalesOrderNo;
			case 4:
				return _subsoUIObj.variantOfProduct;
			case 5:
				return _subsoUIObj.noOfPanels;
			case 6:
				return _subsoUIObj.manfStrategy;
			case 7:
				return _subsoUIObj.actualC40Date;
			case 8:
				return _subsoUIObj.remarkC40Date;
			case 9:
				return _subsoUIObj.actualC50Date;
			case 10:
				return _subsoUIObj.remarkC50Date;
			case 11:
				return _subsoUIObj.actualC60Date;
			case 12:
				return _subsoUIObj.remarkC60Date;

			case 13:
				return _subsoUIObj.reqLineLoadingDate;
			case 14:
				return _subsoUIObj.requestedMechStickerDate;
			case 15:
				return _subsoUIObj.actualMechStickerDate;
			case 16:
				return _subsoUIObj.remarkMechStickerDate;


			case 17:
				return _subsoUIObj.requestedMechElecTestDate;
			case 18:
				return _subsoUIObj.requestedFATDate;
			case 19:
				return _subsoUIObj.plannedImpBrkrRcptDate;
			case 20:
				return _subsoUIObj.requestedImpBrkrRcptDate;
			case 21:
				return _subsoUIObj.supplierImpBrkrRcptDate;
			case 22:
				return _subsoUIObj.actualImpBrkrRcptDate;
			case 23:
				return _subsoUIObj.remarkImpBrkrRcptDate;
			case 24:
				return _subsoUIObj.plannedImpVSCRcptDate;
			case 25:
				return _subsoUIObj.requestedImpVSCRcptDate;
			case 26:
				return _subsoUIObj.supplierImpVSCRcptDate;
			case 27:
				return _subsoUIObj.actualImpVSCRcptDate;

			case 28:
				return _subsoUIObj.remarkImpVSCRcptDate;

			case 29:
				return _subsoUIObj.plannedGERelayRcptDate;
			case 30:
				return _subsoUIObj.requestedGERelayRcptDate;
			case 31:
				return _subsoUIObj.supplierGERelayRcptDate;
			case 32:
				return _subsoUIObj.actualGERelayRcptDate;
			case 33:
				return _subsoUIObj.remarkGERelayRcptDate


			case 34:
				return _subsoUIObj.plannedCTPTRcptDate;
			case 35:
				return _subsoUIObj.requestedCTPTRcptDate;
			case 36:
				return _subsoUIObj.supplierCTPTRcptDate;
			case 37:
				return _subsoUIObj.actualCTPTRcptDate;
			case 38:
				return _subsoUIObj.remarkCTPTRcptDate;


			case 39:
				return _subsoUIObj.plannedRelayRcptDate;
			case 40:
				return _subsoUIObj.requestedRelayRcptDate;
			case 41:
				return _subsoUIObj.supplierRelayRcptDate;
			case 42:
				return _subsoUIObj.actualRelayRcptDate;
			case 43:
				return _subsoUIObj.remarkRelayRcptDate;

			case 44:
				return _subsoUIObj.plannedBreakerRcptDate;
			case 45:
				return _subsoUIObj.requestedBreakerRcptDate;
			case 46:
				return _subsoUIObj.supplierBreakerRcptDate;
			case 47:
				return _subsoUIObj.actualBreakerRcptDate;
			case 48:
				return _subsoUIObj.remarkBreakerRcptDate;


			case 49:
				return _subsoUIObj.plannedJumperRcptDate;
			case 50:
				return _subsoUIObj.requestedJumperRcptDate;
			case 51:
				return _subsoUIObj.supplierJumperRcptDate;
			case 52:
				return _subsoUIObj.actualJumperRcptDate;
			case 53:
				return _subsoUIObj.remarkJumperRcptDate;

			case 54:
				return _subsoUIObj.plannedMeterBoxRcptDate;
			case 55:
				return _subsoUIObj.requestedMeterBoxRcptDate;
			case 56:
				return _subsoUIObj.supplierMeterBoxRcptDate;
			case 57:
				return _subsoUIObj.actualMeterBoxRcptDate;
			case 58:
				return _subsoUIObj.remarkMeterBoxRcptDate;


			case 59:
				return _subsoUIObj.plannedSARcptDate;
			case 60:
				return _subsoUIObj.requestedSARcptDate;
			case 61:
				return _subsoUIObj.supplierSARcptDate;
			case 62:
				return _subsoUIObj.actualSARcptDate;
			case 63:
				return _subsoUIObj.remarkSARcptDate;



			case 64:
				return _subsoUIObj.plannedBoughtoutFabricationRcptDate;
			case 65:
				return _subsoUIObj.requestedBoughtoutFabricationRcptDate;
			case 66:
				return _subsoUIObj.supplierBoughtoutFabricationRcptDate;
			case 67:
				return _subsoUIObj.actualBoughtoutFabricationRcptDate;
			case 68:
				return _subsoUIObj.remarkBoughtoutFabricationRcptDate;
			// case 55:
			// 	return _subsoUIObj.typeOfEquipment
			// case 56://variant of product
			// 	return _subsoUIObj.variantOfProduct;
			// case 57://type of equipment
			// 	return _subsoUIObj.typeOfEquipment;
			// case 58://type of breaker
			// 	return _subsoUIObj.typeOfBreaker;
			// case 59://qty of panel
			// 	return _subsoUIObj.qtyOfPanel;
			// case 60://qty of breaker
			// 	return _subsoUIObj.qtyOfBreaker;
			// case 61://qty of vsc
			// 	return _subsoUIObj.qtyOfVSC;
		}
		return '-'
	}

	prepareSSOUIObjData(_subsoUIObj: UiTblSubSOBrkPSLevel): any {
		_subsoUIObj.plannedManfMonth = this.monthFrmt(_subsoUIObj.sso.planningIP.plannedManufacturingMonth);
		_subsoUIObj.customerName = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.customerName);
		_subsoUIObj.salesOrderNo = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.salesOrderNo);
		_subsoUIObj.subSalesOrderNo = this.strFrmt(_subsoUIObj.sso.subOrderNoId);
		_subsoUIObj.rowHeader = _subsoUIObj.salesOrderNo + '\n' + _subsoUIObj.customerName;
		_subsoUIObj.variantOfProduct = this._dataService.getProductVariantName(_subsoUIObj.sso.pmTechSubSalesOrder.productVarient);
		_subsoUIObj.noOfPanels = this._dataService.getPanelNumName(_subsoUIObj.sso.pmTechSubSalesOrder.numberOfPanels);
		_subsoUIObj.manfStrategy = this._dataService.getManufacturingStrategyName(_subsoUIObj.sso.planningIP.manufacturingStrategy);
		_subsoUIObj.actualC40Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.actualC40Date);
		_subsoUIObj.remarkC40Date = this.strFrmt(_subsoUIObj.sso.enggProcureIP.actualC40Token.addNotes);
		_subsoUIObj.actualC50Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.actualC50Date);
		_subsoUIObj.remarkC50Date = this.strFrmt(_subsoUIObj.sso.enggProcureIP.actualC50Token.addNotes);
		_subsoUIObj.actualC60Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.actualC60Date);
		_subsoUIObj.remarkC60Date = this.strFrmt(_subsoUIObj.sso.enggProcureIP.actualC60Token.addNotes);
		_subsoUIObj.reqLineLoadingDate = this.dtFrmt(_subsoUIObj.sso.planningIP.requestedLineLoadingDate);
		_subsoUIObj.requestedMechStickerDate = this.dtFrmt(_subsoUIObj.sso.productionIP.mechanicalStickerRequestedDate);
		_subsoUIObj.actualMechStickerDate = this.dtFrmt(_subsoUIObj.sso.productionIP.mechanicalStickerActualDate);
		_subsoUIObj.remarkMechStickerDate = this.strFrmt(_subsoUIObj.sso.productionIP.mechanicalStickerActualToken.addNotes);
		_subsoUIObj.requestedMechElecTestDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.mechanicalElectricalTestingRequestedDate);
		_subsoUIObj.requestedFATDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.fatRequestedDate);
		_subsoUIObj.plannedImpBrkrRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerPlannedReceiptDate);
		_subsoUIObj.requestedImpBrkrRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerRequestedReceiptDate);
		_subsoUIObj.supplierImpBrkrRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerSupplierCommittedDate);
		_subsoUIObj.actualImpBrkrRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerActualReceiptDate);
		_subsoUIObj.remarkImpBrkrRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerActualReceiptToken.addNotes);
		_subsoUIObj.plannedImpVSCRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCPlannedReceiptDate);
		_subsoUIObj.requestedImpVSCRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCRequestedReceiptDate);
		_subsoUIObj.supplierImpVSCRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCSupplierCommittedDate);
		_subsoUIObj.actualImpVSCRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCActualReceiptDate);
		_subsoUIObj.remarkImpVSCRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCActualReceiptToken.addNotes);
		_subsoUIObj.plannedGERelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelayPlannedReceiptDate);
		_subsoUIObj.requestedGERelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelayRequestedReceiptDate);
		_subsoUIObj.supplierGERelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelaySupplierCommittedDate);
		_subsoUIObj.actualGERelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelayActualReceiptDate);
		_subsoUIObj.remarkGERelayRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelayActualReceiptToken.addNotes);
		_subsoUIObj.plannedCTPTRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTPlannedReceiptDate);
		_subsoUIObj.requestedCTPTRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTRequestedReceiptDate);
		_subsoUIObj.supplierCTPTRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTSupplierCommittedDate);
		_subsoUIObj.actualCTPTRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTActualReceiptDate);
		_subsoUIObj.remarkCTPTRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTActualReceiptToken.addNotes);
		_subsoUIObj.plannedRelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.relayPlannedReceiptDate);
		_subsoUIObj.requestedRelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.relayRequestedReceiptDate);
		_subsoUIObj.supplierRelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.relaySupplierCommittedDate);
		_subsoUIObj.actualRelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.relayActualReceiptDate);
		_subsoUIObj.remarkRelayRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.relayActualReceiptToken.addNotes);
		_subsoUIObj.plannedBreakerRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerPlannedReceiptDate);

	// 	var _equipments = this.getEquipType(_subsoUIObj.equipment);
	// 	_subsoUIObj.typeOfEquipment = _equipments.equipType;
    // _subsoUIObj.typeOfBreaker = _equipments.breakerType;
    // _subsoUIObj.qtyOfPanel = _equipments.qtyOfPanel;
    // _subsoUIObj.contractualValue = _equipments.contractualvalue;
    // _subsoUIObj.qtyOfVSC = _equipments.VSCQuantity;
    // _subsoUIObj.qtyOfBreaker = _equipments.qtyOfBreaker;
    // _subsoUIObj.breakerPS = _equipments.breakerPS;
    // _subsoUIObj.importedEarthingSwitchApplicability = _equipments.importedSwitch;

		_subsoUIObj.requestedBreakerRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerRequestedReceiptDate);
		_subsoUIObj.supplierBreakerRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerSupplierCommittedDate);
		_subsoUIObj.actualBreakerRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerActualReceiptDate);
		_subsoUIObj.remarkBreakerRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerActualReceiptToken.addNotes);
		_subsoUIObj.plannedJumperRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperPlannedReceiptDate);
		_subsoUIObj.requestedJumperRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperRequestedReceiptDate);
		_subsoUIObj.supplierJumperRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperSupplierCommittedDate);
		_subsoUIObj.actualJumperRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperActualReceiptDate);
		_subsoUIObj.remarkJumperRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperActualReceiptToken.addNotes);
		_subsoUIObj.remarkBreakerRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerActualReceiptToken.addNotes);
		_subsoUIObj.plannedMeterBoxRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxPlannedReceiptDate);
		_subsoUIObj.requestedMeterBoxRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxRequestedReceiptDate);
		_subsoUIObj.supplierMeterBoxRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxSupplierCommittedDate);
		_subsoUIObj.actualMeterBoxRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxActualReceiptDate);
		_subsoUIObj.remarkMeterBoxRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxActualReceiptToken.addNotes);
		_subsoUIObj.plannedSARcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.saPlannedReceiptDate);
		_subsoUIObj.requestedSARcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.saRequestedReceiptDate);
		_subsoUIObj.supplierSARcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.saSupplierCommittedDate);
		_subsoUIObj.actualSARcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.saActualReceiptDate);
		_subsoUIObj.remarkSARcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.saActualReceiptToken.addNotes);
		_subsoUIObj.plannedBoughtoutFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationPlannedReceiptDate);
		_subsoUIObj.requestedBoughtoutFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationRequestedReceiptDate);
		_subsoUIObj.supplierBoughtoutFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationSupplierCommittedDate);
		_subsoUIObj.actualBoughtoutFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationActualReceiptDate);
		_subsoUIObj.remarkBoughtoutFabricationRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationActualReceiptToken.addNotes);

	}
	// getEquipType(_equip: Equipment): any {
	// 	var retVal: any = { "equipType": "", "breakerType": "", "qtyOfPanel": "", "contractualvalue": "", "VSCQuantity ": "", "qtyOfBreaker": "", "breakerPS": "", "importedSwitch": "" };
	
	// 	retVal.equipType = this._dataService.getEquipmentTypeName(_equip.equipmentType);
	// 	retVal.breakerType = this._dataService.getBreakerTypeName(_equip.breakerType);
	// 	retVal.qtyOfPanel = this.frmtNumStr(_equip.panelQuantity);
	// 	retVal.contractualvalue = this.frmtNumStr(_equip.contractualValue);
	// 	retVal.VSCQuantity = this.frmtNumStr(_equip.vscQuantity);
	// 	retVal.qtyOfBreaker = '---';// + this.frmtNumStr(_equip.b);
	// 	retVal.breakerPS = '---';// + this.strFrmt(_equip.breakerPs);
	// 	retVal.importedSwitch = this._dataService.getApplicabilityOptionName(_equip.earthSwithApplicability);
	
	
	// 	return retVal;
	//   }

	strFrmt(_str: string) {
		if (_str) return _str;
		return '';
	}
	frmtNumStr(_numstr: string) {
		if (_numstr) return _numstr;
		return '';
	}
	convNumToStr(_num: number) {
		if (_num) return _num + '';
		return '';
	}
	dtFrmt(_dt: Date): string {
		return GenService.getDateFormatStr(_dt, 'd-mmm-YY')
	}
	monthFrmt(_dt: Date): string {
		return GenService.getDateFormatStr(_dt, 'mmm-YY')
	}

	getColumnName(_index: number): string {
		return GenService.getExcelColumnName(_index);
	}
	reloadData(): void {
		this.loadData();
	}
	tableScrolledLeft: boolean = false;
	onScroll(_scrlEvnt: any) {
		if (_scrlEvnt && _scrlEvnt.srcElement) {
			let _scrollLeft: number = _scrlEvnt.srcElement.scrollLeft;
			this.tableScrolledLeft = (_scrollLeft > 150) ? true : false;
		}
	}
	downloadExcel() {
		this._dataService.downloadFile('manf');
	}
	_rowCounter:number = 0;
  getRowHeader(_sno: number, _rowHeader: string) {
    if (this.tableScrolledLeft == true) {
      return _rowHeader;
    }
    if(_sno == 0) this._rowCounter = 0;
    return (++this._rowCounter) + '';
  }
	getHeadCssClass(_group: UITblGroup): string {
		switch (_group) {
			case UITblGroup.Marketing:
				return 'head-mrkt';
			case UITblGroup.ProjManagement:
				return 'head-pm';
			case UITblGroup.SCM:
				return 'head-scm';
			case UITblGroup.Engineering:
				return 'head-engg';
			case UITblGroup.PurchasePO:
				return 'head-po';
			case UITblGroup.Planning:
				return 'head-plan';
			case UITblGroup.PurchaseMatReceipt:
				return 'head-matrcpt';
			case UITblGroup.Store:
				return 'head-store';
			case UITblGroup.Production:
				return 'head-prod';
			case UITblGroup.Quality:
				return 'head-qual';
			case UITblGroup.Logistics:
				return 'head-log';

		}

		return '';
	}
	filterRows(): void {
		this._filteredSubSoUIObjList = this._filterPipe.transform(this._subSoUIObjList, this.search);
	}
	arrangeHeadColumns(): void {
		let tmpHeadRows: Array<TblHeadCellDef> = [];
		this.headRows.forEach((_Obj: TblHeadCellDef) => {
			var isColumnReq: boolean = true;

			switch (_Obj.cellGroup) {
				case UITblGroup.Marketing:
					if (this.tblModStatus.showMarketing == false) isColumnReq = false;
					break;
				case UITblGroup.ProjManagement:
					if (this.tblModStatus.showPM == false) isColumnReq = false;
					break;
				case UITblGroup.SCM:
					if (this.tblModStatus.showSCM == false) isColumnReq = false;
					break;
				case UITblGroup.Engineering:
					if (this.tblModStatus.showEngg == false) isColumnReq = false;
					break;
				case UITblGroup.PurchasePO:
					if (this.tblModStatus.showPO == false) isColumnReq = false;
					break;
				case UITblGroup.Planning:
					if (this.tblModStatus.showPlanning == false) isColumnReq = false;
					break;
				case UITblGroup.PurchaseMatReceipt:
					if (this.tblModStatus.showMatReceipt == false) isColumnReq = false;
					break;
				case UITblGroup.Store:
					if (this.tblModStatus.showStore == false) isColumnReq = false;
					break;
				case UITblGroup.Production:
					if (this.tblModStatus.showProduction == false) isColumnReq = false;
					break;
				case UITblGroup.Quality:
					if (this.tblModStatus.showQuality == false) isColumnReq = false;
					break;
				case UITblGroup.Logistics:
					if (this.tblModStatus.showLogistics == false) isColumnReq = false;
					break;

			}

			if (isColumnReq == true) {
				tmpHeadRows.push(_Obj);
			}
		});

		this.filteredHeadRows = tmpHeadRows;
	}

	getFooterText(_columnIndex: number): string {
		let aggType: AggregateType = this.filteredHeadRows[_columnIndex].aggregateType
		let _sum: number = 0;
		if (this._filteredSubSoUIObjList && aggType != AggregateType.None) {
			switch (aggType) {
				case AggregateType.COUNT:
					return '';//'('+this._filteredSubSoUIObjList.length + ')';
				case AggregateType.SUM:
					for (var i = 0; i < this._filteredSubSoUIObjList.length; i++) {
						let _tmpVal: number = parseFloat(this.getCellValue(this._filteredSubSoUIObjList[i], _columnIndex));
						if (configDefs.isNumEmty(_tmpVal) == false) {
							_sum += _tmpVal;
						}
					}
					return _sum.toFixed(2);
			}

		}
		return '';
	}

	screenToggle() {
		this.isFullScreenTbl = !this.isFullScreenTbl;
	}

	initTableHeaders(): Array<TblHeadCellDef> {
		let _tmpHeadRows: Array<TblHeadCellDef> = [];

		_tmpHeadRows.push(new TblHeadCellDef("Planned Manufacturing Month","",0,"auto",0,4));
_tmpHeadRows.push(new TblHeadCellDef("Customer Name","",1,"auto",0,0));
_tmpHeadRows.push(new TblHeadCellDef("Sale order number","",2,"auto",0,0));
_tmpHeadRows.push(new TblHeadCellDef("Sub Order Number","",3,"auto",0,0));
_tmpHeadRows.push(new TblHeadCellDef("Variant of Product","",4,"auto",0,0));

_tmpHeadRows.push(new TblHeadCellDef("Quantity of panel","",5,"auto",2,0));
_tmpHeadRows.push(new TblHeadCellDef("Manufacturing strategy","",6,"auto",6,0));
_tmpHeadRows.push(new TblHeadCellDef("Actual C40 Date ","date-text",7,"auto",4,0));
_tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual Date C40","wide-text",8,"auto",4,0));
_tmpHeadRows.push(new TblHeadCellDef("Actual C50 Date ","date-text",9,"auto",4,0));

_tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual Date C50 ","wide-text",10,"auto",4,0));
_tmpHeadRows.push(new TblHeadCellDef("Actual C60 Date ","date-text",11,"auto",4,0));
_tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual Date C60","wide-text",12,"auto",4,0));
_tmpHeadRows.push(new TblHeadCellDef("Requested Line loading date","date-text",13,"auto",6,0));
_tmpHeadRows.push(new TblHeadCellDef("Mechanical sticker Requested date","date-text",14,"auto",9,0));

_tmpHeadRows.push(new TblHeadCellDef("Mechanical sticker Actual date","date-text",15,"auto",9,0));
_tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual Date  Mechanical Sticker","wide-text",16,"auto",9,0));
_tmpHeadRows.push(new TblHeadCellDef("Mechanical/Electrical testing Requested  date","date-text",17,"auto",10,0));
_tmpHeadRows.push(new TblHeadCellDef("FAT Requested date","date-text",18,"auto",10,0));
_tmpHeadRows.push(new TblHeadCellDef("Imported breaker Planned receipt date","date-text",19,"auto",7,0));

_tmpHeadRows.push(new TblHeadCellDef("Imported breaker Requested receipt date","date-text",20,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Imported breaker Supplier  committed date","date-text",21,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Imported breaker Actual receipt date","date-text",22,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual Date for Imported Breaker","wide-text",23,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Imported  VSC Planned receipt date","date-text",24,"auto",7,0));

_tmpHeadRows.push(new TblHeadCellDef("Imported  VSC Requested receipt date","date-text",25,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Imported  VSC Supplier committed date","date-text",26,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Imported  VSC Actual receipt date","date-text",27,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual Date for Imported VSC","wide-text",28,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Special relay planned receipt date","date-text",29,"auto",7,0));

_tmpHeadRows.push(new TblHeadCellDef("Special relay requested receipt date","date-text",30,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Special relay Supplier committed date","date-text",31,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Special relay Actual receipt date","date-text",32,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual Date for Special Relay ","wide-text",33,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("CT / PT Planned Receipt","date-text",34,"auto",7,0));

_tmpHeadRows.push(new TblHeadCellDef("CT / PT requested receipt date","date-text",35,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("CT / PT Supplier committed date","date-text",36,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("CT / PT Actual Receipt","date-text",37,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual Date for CT/PT","wide-text",38,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Relay Planned Receipt","date-text",39,"auto",7,0));

_tmpHeadRows.push(new TblHeadCellDef("Relay Requested receipt date","date-text",40,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Relay Supplier committed date","date-text",41,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Relay Actual Receipt","date-text",42,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual Date for Relay","wide-text",43,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Breaker  Planned receipt","date-text",44,"auto",7,0));

_tmpHeadRows.push(new TblHeadCellDef("Breaker Requested receipt date","date-text",45,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Breaker Supplier committed date","date-text",46,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Breaker Actual receipt","date-text",47,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual Date for Breaker","wide-text",48,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Jumper Planned Receipt","date-text",49,"auto",7,0));

_tmpHeadRows.push(new TblHeadCellDef("Jumper Requested receipt date","date-text",50,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Jumper Supplier committed date","date-text",51,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Jumper Actual Receipt","date-text",52,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual Date  for Jumper","wide-text",53,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Metering Box Planned Receipt","date-text",54,"auto",7,0));

_tmpHeadRows.push(new TblHeadCellDef("Metering Box requested receipt date","date-text",55,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Metering Box supplier committed date","date-text",56,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Metering Box Actual Receipt","date-text",57,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual Date  for Metering Box","wide-text",58,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("SA Planned receipt date","date-text",59,"auto",7,0));

_tmpHeadRows.push(new TblHeadCellDef("SA Requested receipt date","date-text",60,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("SA Supplier committed date","date-text",61,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("SA  receipt date- Actual","date-text",62,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual Date  for SA","date-textwide-text",63,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Boughtout fabrication Planned receipt date","date-text",64,"auto",7,0));

_tmpHeadRows.push(new TblHeadCellDef("Boughtout fabrication requested receipt date","date-text",65,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Boughtout fabrication supplier committed date","date-text",66,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Boughtout fabrication Actual receipt date","",67,"auto",7,0));
_tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual Date for BoughtOut Fabrication","wide-text",68,"auto",7,0));

		
		return _tmpHeadRows;
	}

}
